import { DataLayerServiceModule } from './dataLayer.service';

export const CheckoutTrackerServiceModule = angular
    .module('app.services.tracking.enhancedEcommerce.checkoutTracker', [
        DataLayerServiceModule
    ]).factory('checkoutTracker', ($window, dataLayer) => {
        function logCheckoutStep(product, categoryName, stepNumber, optionValue, listType, position) {
            dataLayer.logCheckoutStep(stepNumber, optionValue,
                [dataLayer.create(product, categoryName, listType, position)]);
        }

        function logAddToCart(currencyCode, product, categoryName, listType, position) {
            dataLayer.logAddToCart(currencyCode, [dataLayer.create(product, categoryName, listType, position)]);
        }

        function logRemoveFromCart(product, categoryName, listType, position) {
            dataLayer.logRemoveFromCart([dataLayer.create(product, categoryName, listType, position)]);
        }

        function logPurchase(
            { orderNumber, affiliation, grandTotal, taxAmount, product, category, paidWith, couponCode }
        ) {
            dataLayer.logPurchase(orderNumber, affiliation, grandTotal, taxAmount,
                [dataLayer.create(product, category)], paidWith, couponCode);
        }

        return {
            logCheckoutStep,
            logAddToCart,
            logRemoveFromCart,
            logPurchase
        };
    }).name;




// WEBPACK FOOTER //
// ./src/app/services/tracking/enhancedEcommerce/checkoutTracker.service.js